import React, { useState, useMemo } from 'react';
import { Button, Form, Modal } from '@/components/ui';
import { Task } from '../../../types/Task';
import { usePermissions } from '../../../hooks/usePermissions';

interface CloseRoutineTaskModalProps {
  visible: boolean;
  task: Task;
  onClose: () => void;
  onSubmit: (comments: string) => Promise<void>;
}

const CloseRoutineTaskModal: React.FC<CloseRoutineTaskModalProps> = ({
  visible,
  task,
  onClose,
  onSubmit
}) => {
  const { hasPermission } = usePermissions();
  const canCloseTask = hasPermission('project:task_close');
  const [comments, setComments] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!canCloseTask) return;
    await onSubmit(comments);
  };

  return (
    <Modal show={visible} onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>Close Task</Modal.Title>
      </Modal.Header>
      {/* Form wraps Body+Footer (footer holds the submit) and is the flex column itself. */}
      <form onSubmit={handleSubmit} className="tw-flex tw-min-h-0 tw-flex-1 tw-flex-col">
        <Modal.Body>
          <div className="tw-mb-3">
            <Form.Label>Comments</Form.Label>
            <Form.Control
              as="textarea"
              value={comments}
              onChange={(e) => setComments(e.target.value)}
              rows={3}
              disabled={!canCloseTask}
            />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" type="button" onClick={onClose}>
            Cancel
          </Button>
          {canCloseTask && (
            <Button variant="primary" type="submit">
              Close Task
            </Button>
          )}
        </Modal.Footer>
      </form>
    </Modal>
  );
};

export default CloseRoutineTaskModal; 